import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import { SupportedLanguages } from '@/types/globals';

/**
 * Get the appropriate locale for dayjs based on the supported language
 */
const getDateLocale = (locale: SupportedLanguages) => {
  return locale === 'fr' ? 'fr' : 'en';
};

/**
 * Format a date string into various formats based on locale
 */
export const formatDate = (dateString: string, locale: SupportedLanguages) => {
  const date = dayjs(dateString);
  const dateLocale = getDateLocale(locale);

  return {
    year: date.year(),
    day: date.date(),
    month: date.locale(dateLocale).format('MMM'),
    full: date.locale(dateLocale).format('dddd, MMMM D, YYYY'),
  };
};

/**
 * Format a time string based on locale
 */
export const formatTime = (timeString: string, locale: SupportedLanguages) => {
  if (!timeString) return '';

  // Create a dayjs object for the time (using a dummy date)
  const time = dayjs(`2000-01-01T${timeString}`);
  const timeLocale = getDateLocale(locale);

  // Use 24-hour format for French, 12-hour for English
  const formatString = locale === 'fr' ? 'HH:mm' : 'h:mm A';

  return time.locale(timeLocale).format(formatString);
};
